module.exports = __webpack_public_path__ + "img/jacket-side-detail.d73af562.jpg";